export const GRE26000 = 'GRE26000'
export const SCHEDULE_CANCEL_REASON_GROUP = 'GRE01000'
export const SCHEDULE_CANCEL_BY_PACIENT = 'RES01001'
export const SCHEDULE_CANCEL_DUE_TECHNICAL_ISSUE = 'RES01002'
export const SCHEDULE_CANCEL_DUE_UNFORESEEN = 'RES01003'